import { Injectable } from "@angular/core";
import { interval } from "rxjs";
import { IUserDetails } from '@irb/app.model';
import { AppService } from "@irb/app.service";
import { ServiceLocator } from "./locator.service";

@Injectable({
  providedIn: "root",
})
export class UtilityService {
  secondMilli = 1000;
  minuteMilli = 60 * this.secondMilli;
  hourMilli = 60 * this.minuteMilli;
  dayMilli = 24 * this.hourMilli;
  private isUiUnitTest = false;
  
  constructor() {    
    this.isUiUnitTest = (window as any).unittestrunningflag;
  }

  incrementDays(d: Date, n: number): Date {
    return new Date(d.getTime() + this.dayMilli * n);
  }

  incrementMonths(d: Date, n:number) {
    return new Date(d.setMonth(d.getMonth() + n));
  }

  //not in use
  // decrementDays(d: Date, n: number): Date {
  //   return new Date(d.getTime() - this.dayMilli * n);
  // }

  formatDateTimeString(dObj: Date, f: string) {
    const y = dObj.getFullYear();
    const m = dObj.getMonth() + 1;
    const d = dObj.getDate();
    const th = dObj.getHours();
    const tm = dObj.getMinutes();
    const ts = dObj.getSeconds();

    const z = (n: number) => {
      const s = String(n);
      return s.length > 1 ? s : "0" + s;
    }

    const x = (n: number) => {
      const h = (n >= 12) ? n - 12 : n;
      return (h === 0) ? 12 : h;
    }

    f = f.replace(/yyyy/, String(y));
    f = f.replace(/yy/, String(y).substr(2));
    f = f.replace(/MM/, z(m));
    f = f.replace(/M/, String(m));
    f = f.replace(/dd/, z(d));
    f = f.replace(/d/, String(d));
    f = f.replace(/hh/, z(x(th)));
    f = f.replace(/mm/, z(tm));
    f = f.replace(/ss/, z(ts));
    f = f.replace(/tt/, (th >= 12) ? "PM" : "AM");
    return f;
  }

  //not in use
  // formatMoney(amount: number, decimalCount = 2, region = "en-us", style = "currency", currency = "USD") {
  //   return new Intl.NumberFormat(region, {
  //     minimumFractionDigits: decimalCount,
  //     style: style,
  //     currency: currency,
  //   }).format(amount);
  // }

  getEasternTime(n: any) {
    const d = new Date(n);
    return d.toLocaleString('en-US',
      {timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second:'numeric' });
  }
  formatEasternDate(item: any, separator: string) {
    if(item && item != null) {
      const estTime = this.getEasternTime(item).split('/');
      let returnItem = '';
      if (estTime.length === 3) {
        const m = Number(estTime[0]);
        const d = Number(estTime[1]);
        const y = estTime[2].substring(0,4);
        returnItem = "" + ((m < 10) ? ("0"+m) : m) + separator + ((d < 10) ? ("0"+d) : d) + separator + y;
      }
      return returnItem;
    } else
      return "";
  }

  //not in use
  // getAbsoluteHeight(el: HTMLElement) {
  //   const styles = window.getComputedStyle(el);
  //   const margin = parseFloat(String(styles["marginTop"]) + parseFloat(String(styles["marginBottom"])));
  //   return Math.ceil(el.offsetHeight + margin);
  // }

  //not in use
  // redirectTo(uri: string, _router: Router) {
  //   _router.navigateByUrl("/", { skipLocationChange: true }).then(() => _router.navigate([uri]));
  // }

  truncate(s: string, n: number) {
    return s.length > n ? s.substr(0, n - 1) + "..." : s;
  }

  compare(objA: any, objB: any, _ignoreList?: Array<String>, consoleOutput?: boolean) {
    const log = (s: string) => {
      if(typeof consoleOutput === "undefined" || consoleOutput === true) {
        if (!this.isUiUnitTest)
          console.log(s);
      }
    };    

    if (objA === null && objB === null) {
      return true;
    } else if (objA === null || objB === null) {
      log("compare: one side of compare is null");
      return false;
    } else if (objA === undefined && objB === undefined) {
      return true;
    } else if (objA === undefined || objB === undefined) {
      log("compare: one side of compare is undefined");
      return false;
    } else if (typeof objA !== typeof objB) {
      log("compare: type " + (typeof objA) + " does not match type " + (typeof objB));
      return false;
    }

    let ignoreList: Array<String> = [];

    if (typeof _ignoreList !== "undefined") {
      ignoreList = _ignoreList;
    }

    for (const index in objA) {
      if (ignoreList.indexOf(index) === -1) {
        if (typeof objA[index] === "object") {
          if (!this.compare(objA[index], objB[index], ignoreList, consoleOutput)) {
            log("compare: index " + index + " does not match. '" + objA[index] + "' does not equal '" + objB[index] + "'");
            return false;
          }
        } else if (!objB.hasOwnProperty(index) || objA[index] !== objB[index]) {
          log("compare: index " + index + " does not match. '" + objA[index] + "' does not equal '" + objB[index] + "'");
          return false;
        }
      }
    }

    for (const index in objB) {
      if (ignoreList.indexOf(index) === -1) {
        if (typeof objB[index] === "object") {
          if (!this.compare(objB[index], objA[index], ignoreList, consoleOutput)) {
            log("compare: index " + index + " does not match. '" + objA[index] + "' does not equal '" + objB[index] + "'");
            return false;
          }
        } else if (!objA.hasOwnProperty(index) || objB[index] !== objA[index]) {
          log("compare: index " + index + " does not match. '" + objA[index] + "' does not equal '" + objB[index] + "'");
          return false;
        }
      }
    }

    return true;
  }

  clone(obj: any): any {
    let copy;

    if (null === obj || "object" !== typeof obj) {
      return obj;
    }

    if (obj instanceof Date) {
      copy = new Date();
      copy.setTime(obj.getTime());
      return copy;
    }

    if (obj instanceof Array) {
      copy = [];
      for (let i = 0, len = obj.length; i < len; i++) {
        copy[i] = this.clone(obj[i]);
      }
      return copy;
    }

    if (obj instanceof Object) {
      copy = {} as any;
      for (const attr in obj) {
        if (obj.hasOwnProperty(attr)) {
          copy[attr] = this.clone(obj[attr]);
        }
      }
      return copy;
    }
    if (!this.isUiUnitTest)
      throw new Error("Unable to copy obj! Its type isn't supported.");
  }

  getFloat(s: string, n: number): number {
    const r = new RegExp("(^-?\\d+\\.\\d{" + n + "})(\\d)");
    const m = s.match(r);
    return m !== null ? parseFloat(m[1]) : parseFloat(s);
  }

  htmlDecode(input: string) {
    const doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  }

  sortString(a: string, b: string) {
    if (a === null || typeof a === "undefined") {
      return -1;
    } else if (b === null || typeof b === "undefined") {
      return 1;
    } else {
      return a.toLowerCase() < b.toLowerCase() ? -1 : a.toLowerCase() > b.toLowerCase() ? 1 : 0;
    }
  }

  sortAsNumber(a: any, b: any) {
      if (a === null || typeof a === "undefined") {
          return -1;
      } else if (b === null || typeof b === "undefined") {
          return 1;
      }
      a = parseFloat(a.replace('%','').replace('$',''));
      b = parseFloat(b.replace('%','').replace('$',''));
      if (a === null || typeof a === "undefined" || isNaN(a)) {
          return -1;
      } else if (b === null || typeof b === "undefined" || isNaN(b)) {
          return 1;
      } else {
          return a < b ? -1 : a > b ? 1 : 0;
      }
  }

  sortByKey(array: Array<any>, key: string, order?: string) {
    order = typeof order === "undefined" ? "desc" : order;

    return array.sort(function (a, b) {
      const x = a[key];
      const y = b[key];

      if (order === "asc") {
        if (typeof x === "string" && typeof y === "string") {
          return x.toLowerCase() < y.toLowerCase() ? -1 : x.toLowerCase() > y.toLowerCase() ? 1 : 0;
        } else {
          return x - y;
        }
      } else {
        if (typeof x === "string" && typeof y === "string") {
          return x.toLowerCase() > y.toLowerCase() ? -1 : x.toLowerCase() < y.toLowerCase() ? 1 : 0;
        } else {
          return y - x;
        }
      }
    });
  }

  getCookie(name: string): string {
    const ca: string[] = [].concat(document.cookie.split(";"));
    const cookieName = name + "=";
    let c: string,
    retVal = null;

    ca.forEach((s: string) => {
      c = s.replace(/^\s+/g, "");
      if (c.startsWith(cookieName)) {
      // return is not stopping forEach loop
        retVal = c.substring(cookieName.length, c.length);
      }
    });

    return retVal; // null
  }

  deleteCookie(name: string) {
    this.setCookie(name, "", -1);
  }

  deleteAllCookies() {
    let cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
        this.setCookie(cookies[i].split("=")[0], "", -1);
    }
  }

  setCookie(name: string, value: string, expireDays: number, path: string = "", samesite = "lax") {
    const d: Date = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    const expires: string = `expires=${d.toUTCString()}`;
    const cpath: string = path ? `; path=${path}` : "";
    const cSameSite: string = `; samesite=${samesite}`;
    document.cookie = `${name}=${value}; ${expires}${cpath}${cSameSite}`;
  }

  insertIframe(iframeId: string, src: string) {
    const iframe = <HTMLIFrameElement>window.document.createElement('iframe');
    iframe.style.display = "none";
    iframe.id = iframeId;
    iframe.src = src;
    window.document.body.appendChild(iframe);
  }

  waitForIframe(iframeId: string, cbFunc: any) {
    const iframe = <HTMLIFrameElement>window.document.getElementById(iframeId);
  
    const timer = interval(250).subscribe(() => {
      if (iframe.contentDocument.readyState === "complete" || iframe.contentDocument.readyState === "interactive") {
        timer.unsubscribe();
        cbFunc(true);
      } else {
        cbFunc(false);
      }
    });
  }

  getTextWidth(e: HTMLElement, str: string) {
    const style = window.getComputedStyle(e, null);
    const font = style.getPropertyValue("font-family");
    const fontSize = style.getPropertyValue("font-size");
    const fontWeight = style.getPropertyValue("font-weight");
    const id = new Date().getTime();

    const temp = document.createElement("span");
    temp.id = String(id);
    temp.innerHTML = str;
    temp.style.whiteSpace = "nowrap";
    temp.style.visibility = "hidden";
    temp.style.fontFamily = font;
    temp.style.fontSize = fontSize;
    temp.style.fontWeight = fontWeight;

    document.body.appendChild(temp);
    const r = temp.getBoundingClientRect();
    const w = r.right - r.left;
    document.body.removeChild(temp);

    return w;
  }

  getEllipsisHTMLElement(e: HTMLElement, depth?: number): HTMLElement {
    if(typeof depth === "undefined") {
      depth = 0;
    } else if (depth >= 5) {
      return null;
    }

    if (e) {
      const p = e.parentElement;
      const style = window.getComputedStyle(e, null);

      if (style.textOverflow !== "ellipsis") {
        return this.getEllipsisHTMLElement(p, ++depth);
      } else {
        return e;
      }
    }

    return null;
  }

  hasTruncation(target: HTMLElement): boolean {
    const textWidth = this.getTextWidth(target, (target.nodeName === "INPUT") ? (<HTMLInputElement>target).value : target.innerHTML);
    const ellipsisNode = this.getEllipsisHTMLElement(target);

    if (ellipsisNode) {
      const style = window.getComputedStyle(ellipsisNode, null);
      const padding = parseInt(style.paddingLeft) + parseInt(style.paddingRight);
      const margin = parseInt(style.marginLeft) + parseInt(style.marginRight);
      const r = ellipsisNode.getBoundingClientRect();
      let i = r.right - r.left;

      if (!isNaN(padding)) {
        i -= padding;
      }

      if (!isNaN(margin)) {
        i -= margin;
      }

      if (i < textWidth) {
        return true; //Ellipsis showing
      } else {
        return false; //Ellipsis NOT showing
      }
    } else {
      return false; //Ellipsis NOT showing
    }
  }

  getObjectValues(obj: any, keyList: Array<string>): any {
    const n = {};

    keyList.forEach((key: string) => {
      if (obj.hasOwnProperty(key)) {
        const v = this.getObjectValue(obj, key);
        this.setObjectValue(n, key, v);
      }
    });

    return n;
  }

  getObjectValue(obj: any, _key: string): any {
    let r = null;

    Object.keys(obj).forEach((key: string) => {
      if (key === _key) {
        r = obj[key];
      }
    });

    return r;
  }

  setObjectValue(obj: any, _key: string, value: any) {
    if (value instanceof Date || value instanceof Array || value instanceof Object) {
      obj[_key] = this.clone(value);
    } else {
      obj[_key] = value;
    }
  }

  compareObjectKeys(obj1: any, obj2: any, _ignoreList?: Array<String>) {
    if(!obj1 || !obj2) return false;
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      console.log("compareObjectKeys: key lengths don't match.");
      return false;
    }

    let ignoreList: Array<String> = [];

    if (typeof _ignoreList !== "undefined") {
      ignoreList = _ignoreList;
    }

    for (const key of keys1) {
      if (ignoreList.indexOf(key) === -1) {
        if (!Object.prototype.hasOwnProperty.call(obj2, key)) {
          console.log("compareObjectKeys: key '" + key + "' is missing.");
          return false;
        }

        if (typeof obj1[key] === 'object' && obj1[key] !== null && typeof obj2[key] === 'object' && obj2[key] !== null) {
          if (!this.compareObjectKeys(obj1[key], obj2[key])) {
            return false;
          }
        }
      }
    }

    return true;
  }

  generateUUID(): string {
    let d = new Date().getTime();

    if (window.performance && typeof window.performance.now === "function") {
      d += performance.now(); //use high-precision timer if available
    }

    const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });

    return uuid;
  }

  generateSchwabUUID(): string {
    const s4 = () => {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

  getEnv(): string {
    let env = "SIT01";

    if(location.hostname.startsWith("irebal-dev") || location.hostname.startsWith("irebal-sit01")) {
      env = "SIT01";
    } else if(location.hostname.startsWith("irebal-qa") || location.hostname.startsWith("irebal-qae01")) {
      env = "QAE01";
    } else if(location.hostname.startsWith("irebal-pvs") || location.hostname.startsWith("irebal-pte01")) {
      env = "PTE01";
    } else if(location.hostname.startsWith("irebal-s4") || location.hostname.startsWith("irebal-pre01")) {
      env = "PRE01";
    } else if(location.hostname.startsWith("irebal-s5")) {
      env = "S5";
    } else if(location.hostname.startsWith("irebal.schwab")) {
      env = "PROD";
    } else if(location.hostname.startsWith("irebal-hen")) {
      env = "UAT";
    } else if(location.hostname.startsWith("irebal-api-gateway-service-dev1")){
      env = "DEV01";
    }

    return env;
  }

  encodeForCSV(s: string): string {
    s = s?.replace(/'/g,"''");
    s = s?.replace(/"/g,'""');
    return (s) ? "\"" + s + "\"" : "";
  }

  sortArrayList(arrayList: string[]) {
    return arrayList.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
  }

  getSACDomain(): string {
    let domain = 'sac.schwabinstitutional.com';

    if(location.hostname.startsWith("irebal-dev") || location.hostname.startsWith("irebal-sit01")) {
      domain = "si2-sit01.dev.schwab.tech";
    } else if(location.hostname.startsWith("irebal-qa") || location.hostname.startsWith("irebal-qae01")) {
      domain = "si2-qae01.dev.schwab.tech";
    } else if(location.hostname.startsWith("irebal.schwab")) {
      domain = "sac.schwabinstitutional.com";
    } else if(window.location.hostname === "localhost") {
      domain = "si2-sit01.dev.schwab.tech";
    } else if(location.hostname.startsWith("irebal-pre")) {
      domain = "si2-pre01.dev.schwab.tech";
    }

    return domain;
  }

  getSACShellDomain(): string {
    let domain = 'sac.schwabinstitutional.com';

    if(location.hostname.startsWith("irebal-dev") || location.hostname.startsWith("irebal-sit01")) {
      domain = "sac-shell-ui-sit01.dev.schwab.tech";
    } else if(location.hostname.startsWith("irebal-qa") || location.hostname.startsWith("irebal-qae01")) {
      domain = "sac-shell-ui-qae01.dev.schwab.tech";
    } else if(location.hostname.startsWith("irebal.schwab")) {
      domain = "sac.schwabinstitutional.com";
    } else if(window.location.hostname === "localhost") {
      domain = "sac-shell-ui-sit01.dev.schwab.tech";
    } else if(location.hostname.startsWith("irebal-pre")) {
      domain = "sac-shell-ui-pre01.dev.schwab.tech";
    }

    return domain;
  }

  getSacContextGatewayBaseURL(): string {
    if (window.location.hostname === 'localhost') {
      return 'https://jfk.dev.schwab.com';
    }
    
    const encodedSacContextGatewayURL = window.sessionStorage.getItem('IRB_SAC_CONTEXT_GATEWAY_URL');
    return encodedSacContextGatewayURL ? window.atob(encodedSacContextGatewayURL) : '';
  }
  
  //converts date to ET in format 'yyyy-mm-dd' to be used in date filters
  static convertDateTimeToETforFilter(dateChange: any) {
    let localDate = dateChange.toLocaleDateString('en-US',{timeZone:'America/New_York', month:'2-digit', day:'2-digit', year: 'numeric'});
    let monthDate = localDate.substring(0,2);
    let dateDate = localDate.substring(3,5);
    let dateFullYear = localDate.substring(6,10);
    const dCreated = dateFullYear +'-'+ monthDate + '-' + dateDate;
    return dCreated;
  }
  static formatAmountWithAbbreviation(amount: number): string {
    if (amount < 1_000) {
      return `${amount.toLocaleString()}`;
    } else if (amount < 1_000_000) {
      const thousands = amount / 1_000;
      return `${thousands.toFixed(1)} K`;
    } else if (amount < 1_000_000_000) {
      const millions = amount / 1_000_000;
      return `${millions.toFixed(1)} M`;
    } else if (amount < 1_000_000_000_000) {
      const billions = amount / 1_000_000_000;
      return `${billions.toFixed(1)} B`;
    } else {
      const trillions = amount / 1_000_000_000_000;
      return `${trillions.toFixed(1)} T`;
    }
  }

  parseCsv(csv: string, hasHeaderInCsv = false, headerList:string[], reader: any): any[] {
    /*
    * headerList example: ['modelMarketId','modelMarketName','security','target','modelType','sourceId']
    * some scv file may not have header row, so we must pass hasHeaderInCsv =false and headerList to use instead
    * if hasHeaderInCsv = true, and headerList is defined then it will be used instead of the first row in csv
    * if hasHeaderInCsv = true and headerList = null then the first row in csv will be used as header
    */

    const rows = csv.split('\n').filter(row => row.replace(/,/g,'').trim() !== '');
    let headers: string[];
    if (!hasHeaderInCsv)
      headers = headerList;
    else if (headerList) {
      headers = headerList;
      rows.shift();
    } else
      headers = this.parseRow(rows.shift()!); // Extract headers
    return rows.map(row => {
      const values = this.parseRow(row); // row.replace(/"/g, '\\"')
      if (values.length !== headers.length) {
        reader.abort();
        throw new Error(`Row has ${values.length} values, but expected ${headers.length}.`);
      }
      return headers.reduce((obj, header, index) => {
        obj[header] = values[index] || null;
        return obj;
      }, {} as Record<string, any>);
    });
  }

  parseRow(row: string): string[] {
    const result: string[] = [];
    let current = '';
    let inQuotes = false;

    for (let i = 0; i < row.length; i++) {
      const char = row[i];
      if (char === '"' && (i === 0 || row[i - 1] !== '\\')) {
        inQuotes = !inQuotes;
      } else if (char === ',' && !inQuotes) {
        result.push(current.trim());
        current = '';
      } else {
        current += char;
      }
    }
    result.push(current.trim());
    return result;
  }
}
